import React from 'react';
import { Dropdown, DropdownAnchor, DropdownContent, DropdownSectionColumn } from '@fiverr-private/dropdown';
import { translate } from '@fiverr-private/i18n-react';
import { type Link } from '../../../shared/getContentLinks';
import { globalMixpanelReporter } from '../../../events/mixpanel';
import { globalBigQueryReporter } from '../../../events/bigQuery';
import { BIG_QUERY_GROUP_HEADER_CLICKS } from '../../../events/bigQuery/bigQuery.constants';
import { LogoMakerTriggerButton } from '../../../blocks/TriggerButton';
import { DropdownColumnContent } from '../../../blocks/DropdownColumnContent';
import { getLogoMakerContentLinks } from './getLogoMakerContentLinks';

export const ExploreDropdown = () => {
    const { popularLogosLinks, solutionsLinks, learnDiscoverLinks } = getLogoMakerContentLinks();

    const handleMenuItemClick = ({ url, label, bigQueryEventName }: Link) => {
        globalMixpanelReporter.send('Clicked logged out header - sub item', {
            'Item Text': label,
            'Item Destination': url,
            'Main Item Text': 'Explore',
        });
        globalBigQueryReporter.send(bigQueryEventName, {
            group: BIG_QUERY_GROUP_HEADER_CLICKS,
        });
    };

    return (
        <Dropdown position="bottom-end">
            <DropdownAnchor embed>
                <LogoMakerTriggerButton>{translate('header.logo_maker.explore')}</LogoMakerTriggerButton>
            </DropdownAnchor>
            <DropdownContent
                templateColumns={{
                    default: '100%',
                    sm: '33%_33%_33%',
                }}
                variant="sections"
            >
                <DropdownSectionColumn>
                    <DropdownColumnContent
                        title={translate('header.logo_maker.popular_logos')}
                        links={popularLogosLinks}
                        onClick={handleMenuItemClick}
                    />
                </DropdownSectionColumn>
                <DropdownSectionColumn>
                    <DropdownColumnContent
                        title={translate('header.logo_maker.solutions')}
                        links={solutionsLinks}
                        onClick={handleMenuItemClick}
                    />
                </DropdownSectionColumn>
                <DropdownSectionColumn>
                    <DropdownColumnContent
                        title={translate('header.logo_maker.learn_discover')}
                        links={learnDiscoverLinks}
                        onClick={handleMenuItemClick}
                    />
                </DropdownSectionColumn>
            </DropdownContent>
        </Dropdown>
    );
};
